import { app } from '../../../app';
import { appProtocolDisplayName } from '../../../../util/sp-util';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management', {
        url: '/software-license-management',
        redirectTo: 'company.software-license-management.list',
        component: 'companySoftwareLicenseManagement',
        resolve: {softwareLicenseManagementInfos},
    });
}

/** @ngInject */
function softwareLicenseManagementInfos(SoftwareLicenseManagementService, companyId) {
    return SoftwareLicenseManagementService.getSoftwareLicenseManagementInfos(companyId)
        .then(softwareLicenseManagementInfos => {
            softwareLicenseManagementInfos
                .forEach(softwareLicenseManagementInfo => {
                    softwareLicenseManagementInfo.costSavings = softwareLicenseManagementInfo.licenseCost * softwareLicenseManagementInfo.orphanAccounts;
                    let app = softwareLicenseManagementInfo.application;
                    app.samlAppLogo = window.env.urls.samlAppLogo(softwareLicenseManagementInfo.application.slug, 'thumb');
                    setDisplayNames(app);
                    if (app.publicService && app.publicService.serviceName === 'other') {
                        app.publicService.serviceName = 'Custom'
                    }
            });
            return softwareLicenseManagementInfos;
        })
}

function setDisplayNames(application) {
    application.typeDisplayName = typeDisplayName(application);
    application.protocolDisplayName = appProtocolDisplayName(application);
}

function typeDisplayName(app) {
    let displayName = app.publicService ? app.publicService.serviceName + ' - ' + app.applicationTypeDisplayName : app.applicationTypeDisplayName;
    return displayName;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/software-license-management.state.js